import { render, staticRenderFns } from "./customerSalesTable.vue?vue&type=template&id=097b55bb&scoped=true"
import script from "./customerSalesTable.vue?vue&type=script&lang=js"
export * from "./customerSalesTable.vue?vue&type=script&lang=js"
import style0 from "./customerSalesTable.vue?vue&type=style&index=0&id=097b55bb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097b55bb",
  null
  
)

export default component.exports